import { BfiApi, IApiResponse } from './bfiApi';

export interface ITempFile {
    tempName: string;
    cleanedName: string;
}

export interface ITaxDocumentReviewRequest {
    token: string;
}

export interface IUploadTempFileResponse extends Omit<IApiResponse, 'result'> {
    result: [ITempFile];
}

export interface ITaxReviewLineItem {
    name: string;
    category: string;
    match: string;
    returnAmount: string;
    transcriptAmount: string;
    difference: string;
}

export interface ITaxReviewResult {
    lineItems: ITaxReviewLineItem[];
}

export interface IGetTaxReviewResult {
    id: string;
    isReady: boolean;
    result: ITaxReviewResult;
}

export interface IGetTaxReviewResponse {
    result: IGetTaxReviewResult;
}

export interface ITaxReviewResponse {
    result: string;
}

export interface ITaxReviewResultForYear {
    [key: string]: ITaxReviewResult;
}

export class DocumentReviewApi extends BfiApi {
    reviewTaxDocuments(returnFile: any, transcriptFile: any): Promise<ITaxReviewResponse> {
        const formData = new FormData();
        formData.append('returnFile', returnFile);
        formData.append('transcriptFile', transcriptFile);
        return super.post('/documentreview/reviewtaxdocuments', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    pollTaxDocumentResults(id: string): Promise<IGetTaxReviewResponse> {
        return super.get<IGetTaxReviewResponse>(`/documentreview/gettaxdocumentreviewresults?id=${id}`);
    }

    generateReport(worksheets: any[]): Promise<IUploadTempFileResponse> {
        const payload = {
            worksheets,
        };
        return super.post('/documentreview/generatecomparisonreport', payload, {
            responseType: 'blob',
        });
    }
}
